<template>
	<div>
		fdsfsafs
	</div>
</template>
<script>
	import Vue from "vue"
	import commonService from "../../services/common";
	export default {
		name: "Session",
		beforeRouteEnter(to, from, next) {
			next();
		},
		created() {
			this.isParentAlive();
		},
		mounted() {
		},
		data() {
			return {
				vModel: {
					NewPhone: null,
					ConfirmPhone: null,
					Password: null
				}
			};
		},
		methods: {
			isParentAlive: function () {
				setInterval(() => {
					if (!window.opener) {
						commonService.removeStorage('token')
						commonService.removeStorage('name')
						commonService.removeStorage('refreshToken')
						commonService.removeStorage('completeRegistration');
						commonService.removeStorage('phoneNumberConfirmed');
						commonService.removeStorage('countryFlag');
						commonService.removeStorage('lastLoginDate');
						commonService.removeStorage('userKycStatus');
						commonService.removeStorage('ekycEnable');
						window.close()
					}
				}, 2000);
			}
		}
	};
</script>

